import { createSelector } from 'reselect';
import getAdminObjectData from '../getAdminObjectData';

export const adminObjectSelector = ({ administration }) => administration.adminImport.selectedAdminObject;
export const isFetchingAdminObjectSelector = ({ administration }) => administration.adminImport.isFetching;

export const adminObjectToExportSelector = createSelector(
  state => state,
  adminObjectSelector,
  (state, adminObject) => {
    const selector = getAdminObjectData(adminObject).selector;
    return selector(state);
  }
);
